<template>
  <div v-if="computedBikeparkSignsVisibility">
    <v-dialog
      v-model="computedBikeparkSignsVisibility"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card>
          <v-btn icon @click="methodToggleListView('bikepark', 'signs')">
            <v-icon>close</v-icon>
          </v-btn>

          <v-toolbar-title class="hidden-sm-and-down"
            >Bike Park Signage</v-toolbar-title
          >
          <v-spacer class="hidden-sm-and-down"></v-spacer>
          <v-btn @click="addSign = true" color="info">Add Sign</v-btn>
          <v-spacer class="hidden-sm-and-down"></v-spacer>
          <v-text-field
            append-icon="search"
            single-line
            hide-details
            v-model="search"
            placeholder="Filter data"
          ></v-text-field>
        </v-toolbar>
        <div
          style="
            background-color: black;
            padding-left: 30px;
            overflow: auto;
            -webkit-overflow-scrolling: touch;
          "
        >
          <v-data-table
            :headers="headers"
            :items="computedBikeparkSignsGeoJsonFeatures"
            :rows-per-page-items="rows_per_page"
            :rows-per-page-text="rows_per_page_text"
            :search="search"
            class="elevation-1"
            :loading="computedBikeparkSignsLoading"
          >
            <template slot="items" slot-scope="props">
              <tr
                @click="
                  methodToggleSingleLayer(
                    'bikepark',
                    'signs',
                    true,
                    props.item.properties.id
                  )
                "
              >
                <td>{{ props.item.properties.trail_name }}</td>
                <td>{{ props.item.properties.sign_loc }}</td>
                <td>{{ props.item.properties.feat_num }}</td>
                <td>{{ props.item.properties.modified }}</td>
              </tr>
            </template>

            <!-- Alert when no results found -->
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
              >Your search for "{{ search }}" found no results.</v-alert
            >
          </v-data-table>
        </div>
        <div style="flex: 1 1 auto"></div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="addSign"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card>
          <v-btn
            icon
            @click="
              addSign = false;
              clearWatchLocation();
              lat = null;
              lng = null;
              accuracy = null;
              altitude = null;
              data_comments = null;
              data_trail_name = null;
              data_sign_loc = null;
            "
          >
            <v-icon>close</v-icon>
          </v-btn>

          <v-toolbar-title class="hidden-sm-and-down">Add Sign</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!tracking"
            :disabled="tracking"
            color="success"
            @click="geoWatchPosition()"
            >Start GPS</v-btn
          >
          <v-btn
            v-if="tracking"
            :disabled="!tracking"
            color="error"
            @click="clearWatchLocation()"
            >Stop GPS</v-btn
          >
          <v-spacer></v-spacer>
        </v-toolbar>
        <div
          style="
            background-color: black;
            padding-left: 30px;
            overflow: auto;
            -webkit-overflow-scrolling: touch;
          "
        >
          <v-data-table
            v-if="addSign"
            :items="addItemBlank"
            :hide-headers="addItemHideHeaders"
            :hide-actions="addItemHideActions"
          >
            <template slot="items">
              <tr>
                <td>Image</td>
                <td>
                  <image-uploader
                    @input="setOutput"
                    :debug="2"
                    :quality="0.9"
                    :autoRotate="attemptAutoRotate"
                    outputFormat="base64"
                    class="fileinput2"
                    :preview="true"
                    accept=".jpg, .jpeg"
                  ></image-uploader>
                </td>
              </tr>
              <tr>
                <td>EXIF rotate?</td>
                <td><v-checkbox v-model="attemptAutoRotate" class="mt-2" /></td>
              </tr>
              <tr>
                <td>Latitude</td>
                <td>
                  <span v-if="!lat && tracking">Getting latitude...</span>
                  {{ lat }}
                </td>
              </tr>
              <tr>
                <td>Longitude</td>
                <td>
                  <span v-if="!lng && tracking">Getting longitude...</span>
                  {{ lng }}
                </td>
              </tr>
              <tr>
                <td>Accuracy</td>
                <td>
                  <span v-if="!accuracy && tracking">Getting accuracy...</span>
                  {{ accuracy }}
                  <span v-if="accuracy">m</span>
                </td>
              </tr>
              <tr>
                <td>Altitude</td>
                <td>
                  <span v-if="!altitude && tracking">Getting altitude...</span>
                  {{ altitude }}
                  <span v-if="altitude">m</span>
                </td>
              </tr>
              <tr>
                <td>Trail Name</td>
                <td>
                  <v-select
                    v-model="data_trail_name"
                    :items="computedUniqueTrailNames"
                    ref="signs_add_trail_name"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Location</td>
                <td>
                  <v-select
                    v-model="data_sign_loc"
                    :items="computedUniqueLocations"
                    ref="signs_add_sign_loc"
                  ></v-select>
                </td>
              </tr>
              <tr>
                <td>Feature Number</td>
                <td>
                  <v-text-field
                    v-model="data_feat_num"
                    name="signs_add_feat_num"
                    ref="signs_add_feat_num"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td>Comments</td>
                <td>
                  <v-textarea
                    v-model="data_comments"
                    name="signs_add_comments"
                    ref="signs_add_comments"
                  ></v-textarea>
                </td>
              </tr>
            </template>
            <template slot="footer">
              <tr>
                <td colspan="100%">
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                  <v-btn
                    @click.stop="
                      methodAddBikeparkSignsGeoJson({
                        lat: lat,
                        lng: lng,
                        trail_name: $refs.signs_add_trail_name.value,
                        sign_loc: $refs.signs_add_sign_loc.value,
                        feat_num: $refs.signs_add_feat_num.value,
                        comments: $refs.signs_add_comments.value,
                        description: $refs.signs_add_comments.value,
                        lasteditor: computedAuth.profile.email,
                        modified: pgDate(Date.now()),
                        base64data: base64image
                      });
                      addSign = false;
                      clearWatchLocation();
                      lat = null;
                      lng = null;
                      accuracy = null;
                      altitude = null;
                      data_comments = null;
                      data_trail_name = null;
                      data_sign_loc = null;
                      data_feat_num = null;
                    "
                    color="success"
                    >Save</v-btn
                  >
                  <v-spacer class="hidden-sm-and-down"></v-spacer>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<style>
.fileinput2 {
  color: green;
}
</style>
<script>
("dataBikeparkSigns");
export default {
  data() {
    return {
      attemptAutoRotate: false,
      base64image: null,
      lat: null,
      lng: null,
      accuracy: null,
      altitude: null,
      data_comments: null,
      data_sign_loc: null,
      data_feat_num: null,
      data_trail_name: null,
      addItemBlank: [""],
      addItemHideHeaders: true,
      addItemHideActions: true,
      watchId: null,
      tracking: false,
      addSign: false,
      loading: true,
      search: "",
      rows_per_page: [
        10,
        25,
        50,
        {
          text: "All",
          value: -1
        }
      ],
      rows_per_page_text: "Per page:",
      headers: [
        {
          text: "Trail Name",
          value: "properties.trail_name"
        },
        {
          text: "Sign Location",
          value: "properties.sign_loc"
        },
        {
          text: "Feature Number",
          value: "properties.feat_num"
        },
        {
          text: "Modified",
          value: "properties.modified"
        }
      ],
      opt_rope: [
        {
          text: "Yes",
          value: "yes"
        },
        {
          text: "No",
          value: "no"
        },
        {
          text: "Unknown",
          value: ""
        }
      ],
      opt_source: [
        { text: "CAD-GPS" },
        { text: "Phone" },
        { text: "Eye Ball" },
        { text: "Unknown" }
      ],
      opt_condition: [
        { text: "Good Condition" },
        { text: "Good Condition/ But Short" },
        { text: "Poor Condition/ Needs Replacement" },
        { text: "Buried" },
        { text: "Remove" },
        { text: "Miscellaneous" },
        { text: "Proposed" },
        { text: "Unknown" }
      ],
      opt_purpose: [
        { text: "Avalanche Closure" },
        { text: "Boundary" },
        { text: "Cliff" },
        { text: "Permanent Closure" },
        { text: "Gate" },
        { text: "Information Sign" },
        { text: "Unknown" }
      ],
      opt_sign: [
        {
          text: "Yes",
          value: "yes"
        },
        {
          text: "No",
          value: "no"
        },
        {
          text: "Unknown",
          value: ""
        }
      ]
    };
  },
  computed: {
    computedUniqueTrailNames() {
      const trailNames = this.$store.state.mapLayers.bikepark.layers.signs
        .geojson.features;

      let a = []; // blank array
      for (let i = 0; i < trailNames.length; i++) {
        a.push(trailNames[i].properties.trail_name); // push all trails into array a
      }

      return a.unique().sort(); // returns sorted unique trail names
    },
    computedUniqueLocations() {
      const locations = this.$store.state.mapLayers.bikepark.layers.signs
        .geojson.features;

      let a = []; // blank array
      for (let i = 0; i < locations.length; i++) {
        if (locations[i].properties.sign_loc !== null) {
          a.push(locations[i].properties.sign_loc); // push all sign locations into array a
        }
      }
      return a.unique().sort(); // returns sorted unique sign locations
    },
    computedBikeparkSignsGeoJsonFeatures() {
      if (this.$store.state.mapLayers.bikepark.layers.signs.geojson.features) {
        const signs = this.$store.state.mapLayers.bikepark.layers.signs.geojson
          .features;

        let hideHidden = signs.filter(item => item.properties.hidden != "true");
        return hideHidden;
      }
      return [];
    },
    computedBikeparkSignsVisibility() {
      return this.$store.state.mapLayers.bikepark.layers.signs.visibility
        .listView;
    },
    computedBikeparkSignsLoading() {
      return this.$store.state.mapLayers.bikepark.layers.signs.loading;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedAuth() {
      return this.$store.state.auth;
    }
  },
  methods: {
    pgDate(date) {
      function zeroPad(d) {
        return ("0" + d).slice(-2);
      }

      var parsed = new Date(date);

      return [
        parsed.getUTCFullYear() +
          "-" +
          zeroPad(parsed.getMonth() + 1) +
          "-" +
          zeroPad(parsed.getDate()) +
          " " +
          zeroPad(parsed.getHours()) +
          ":" +
          zeroPad(parsed.getMinutes()) +
          ":" +
          zeroPad(parsed.getSeconds())
      ].join(" ");
    },
    setOutput(file) {
      this.base64image = file;
    },
    geoSuccess(position) {
      this.lat = position.coords.latitude;
      this.lng = position.coords.longitude;
      this.accuracy = position.coords.accuracy;
      this.altitude = position.coords.altitude;
    },
    geoError() {
      console.log("geo error");
    },
    geoWatchPosition() {
      let geoOptions = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      };
      this.tracking = true;
      this.watchId = navigator.geolocation.watchPosition(
        this.geoSuccess,
        this.geoError,
        geoOptions
      );
    },
    clearWatchLocation() {
      navigator.geolocation.clearWatch(this.watchId);
      this.tracking = false;
    },
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      if (utcdate !== null) {
        return y + "-" + m + "-" + d;
      } else {
        return;
      }
    },
    // method to get geojson
    methodGetBikeparkSignsGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/bikepark/signs",
        dept: "bikepark",
        layer: "signs",
        token: this.computedAuthToken
      });
    },
    methodAddBikeparkSignsGeoJson(data) {
      let constFeature = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [data.lng, data.lat]
            },
            properties: {
              trail_name: data.trail_name,
              sign_loc: data.sign_loc,
              comments: data.comments,
              lasteditor: data.lasteditor,
              modified: data.modified
            }
          }
        ]
      };
      this.$store
        .dispatch("actionAddJsonImage", {
          url: "https://api2.alchemymapping.com/vail/whistler/bikepark/signs",
          imageUrl:
            "https://api2.alchemymapping.com/vail/whistler/bikepark/signs/image",
          base64data: this.base64image,
          dept: "bikepark",
          layer: "signs",
          token: this.computedAuthToken,
          payload: constFeature
        })
        .then(
          setTimeout(() => {
            this.methodGetBikeparkSignsGeoJson();
          }, 250)
        );
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.bikepark.layers.signs.visibility.listView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetBikeparkSignsGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.bikepark.layers.signs.geojson": function(newValue) {
      if (
        newValue &&
        this.$store.state.mapLayers.bikepark.layers.signs.geojson
      ) {
        this.loading = false;
      }
    }
  }
};
</script>
